module.exports = __webpack_public_path__ + "static/media/Vu_Minh_Hai.e3eed7fd.jpg";